import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminSubmissions() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/submissions").then(({ data }) => setItems(data.submissions)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/admin/submissions/${id}/read`).catch(() => {});
    load();
  };

  return (
    <div data-testid="admin-submissions">
      <h1 className="font-serif text-3xl font-semibold text-forest">Contact &amp; volunteer enquiries</h1>
      <p className="mt-2 text-sm text-charcoal/70">Private submissions from the website forms. Never expose these publicly.</p>
      <div className="mt-6 space-y-4">
        {items.map((s) => (
          <article key={s.id} className={`bg-white border p-6 ${s.read ? "border-sandstone" : "border-gold"}`} data-testid={`submission-${s.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <p className="text-xs uppercase tracking-wider font-semibold text-gold-dark">{s.type}{!s.read && " — unread"}</p>
                <h2 className="mt-1 font-serif text-xl font-semibold text-charcoal">{s.subject}</h2>
                <p className="mt-1 text-xs text-charcoal/60">
                  {s.name} · <a className="text-forest underline" href={`mailto:${s.email}`}>{s.email}</a> · {new Date(s.created_at).toLocaleString("en-GB")}
                </p>
              </div>
              {!s.read && (
                <button onClick={() => markRead(s.id)} data-testid={`submission-read-${s.id}`}
                  className="text-xs border border-sage px-4 py-2 hover:bg-sandstone transition-colors duration-300">
                  Mark as read
                </button>
              )}
            </div>
            <p className="mt-4 text-sm text-charcoal/80 leading-relaxed whitespace-pre-wrap">{s.message}</p>
          </article>
        ))}
        {items.length === 0 && (
          <div className="bg-sandstone/50 border border-sandstone p-8 text-sm text-charcoal/60 text-center">No enquiries yet.</div>
        )}
      </div>
    </div>
  );
}
